import React, { useEffect, useState } from "react";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import PdfDocument from "../generateInvoice/Invoice";
import { db, collection, ref, onSnapshot, uploadBytes, storage } from '../../config/firebase';
import { Button } from "@material-tailwind/react";
import './style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faDownload } from '@fortawesome/free-solid-svg-icons';
export function BestPdf() {
  
  const [data, setData] = useState([]);

  useEffect(() => {
    const uid = JSON.parse(localStorage.getItem("Student"));
    const q = collection(db, "Students");
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const newData = [];
      snapshot.forEach((doc) => {
        if (uid?.uid === doc.id) newData.push(doc.data());
      });
      setData(newData);
    });

    return () => {
      unsubscribe(); 
    };
  }, []);
const fileName = "std_"+data[0]?.rollNumber;
  return (
    <>
      <div className="App">
      {/* <PDFViewer width={800}  height={500} showToolbar={false}>
        <PdfDocument invoicedata={data || data[0]} />
      </PDFViewer> */}
      <div className="download-link flex justify-center items-center">
    


     
      <PDFDownloadLink  
          document={<PdfDocument invoicedata={data?data[0]:data[0] } />}
          fileName={fileName}
        >
      
        
          {({ blob, url, loading, error }) => {
            setTimeout(()=>{

              const storageRef = ref(storage, `pdfs/${data[0]?.rollNumber}`);
              uploadBytes(storageRef, blob).then((snapshot) => {
                console.log('Uploaded a blob or file!');
              },3000)
});
   

            return (loading ? "Loading..." :  <Button className="flex justify-center border-2 items-center  download-button"  style={{ marginRight: '10px',fontSize:'20px' ,backgroundColor: "#0B5F68" }} >      <FontAwesomeIcon  icon={faDownload} style={{ color: "white", marginRight: "10px" }}  shake size="lg" />Download ID Card</Button>)
          }
        
          
          
          }
        </PDFDownloadLink>
    
    
  
    
      </div>
</div>

    </>
  );
}